import * as React from 'react';
import {FormattedMessage} from '@meiko/react-intl';
import {getListItemBuilding, getListItemClient, getListItemLead} from 'utils/lists';
import {LISTABLE_TYPES, LISTABLE_TYPES_MODELS} from 'dicts/lists';
import msgs from 'dicts/messages';

import Modal from 'components/generic/Modal';
import ModalHeaderTitle from 'components/generic/ModalHeaderTitle';
import Button from 'components/generic/Button';
import LeadDetailsPanel from './LeadDetailsPanel';
import BuildingPanel from './BuildingPanel';
import ClientPanel from './ClientPanel';
import LeadAdditionalInfoPanel from './LeadAdditionalInfoPanel';
import LeadEventsPanel from './LeadEventsPanel';
import CommentsPanel from './CommentsPanel';

export default function ListItemDetailsModal({
	listItem,
	processCallback,
	onClose,
	onRemoveFromList,
}) {
	const building = getListItemBuilding(listItem);
	const client = getListItemClient(listItem);
	const lead = getListItemLead(listItem);

	const itemType = LISTABLE_TYPES_MODELS[listItem.listableType];
	const listable = listItem.listable.data;

	const buildingProductStates =
		itemType === LISTABLE_TYPES.buildings
			? listable?.allBuildingProductStates?.data
			: itemType === LISTABLE_TYPES.clients
			? listable?.building?.data?.allBuildingProductStates?.data
			: itemType === LISTABLE_TYPES.leads
			? listable?.building?.data?.allBuildingProductStates?.data
			: [];

	return (
		<Modal
			className="!w-[1200px]"
			hide={onClose}
			footerLeft={
				onRemoveFromList && (
					<Button appearance="error" onClick={onRemoveFromList}>
						<FormattedMessage id={msgs.remove} />
					</Button>
				)
			}
			cancelButton={
				<Button onClick={onClose}>
					<FormattedMessage id="Close" />
				</Button>
			}
			headerTitle={
				<ModalHeaderTitle>
					<FormattedMessage id="Additional information" />
				</ModalHeaderTitle>
			}
		>
			<div className="space-y-6 py-6">
				<LeadDetailsPanel lead={lead} />
				<BuildingPanel
					building={building}
					lead={lead}
					buildingProductStates={buildingProductStates}
				/>
				<ClientPanel client={client} lead={lead} />
				<LeadAdditionalInfoPanel
					lead={lead}
					products={listItem?.listable?.data?.products?.data ?? []}
					url={listItem.listable?.data?.url}
					organization={listItem?.listable?.data?.organization?.data}
				/>
				<LeadEventsPanel lead={lead} />
				<CommentsPanel listItem={listItem} saveCallback={processCallback} />
			</div>
		</Modal>
	);
}
